export enum TEST_EQUIPMENT_DEVICE_SELECTION {
  DEFAULT = 'default_device',
  ATHLETE = 'athlete_device',
  ANOTHER = 'another_device',
}

export enum TEST_EQUIPMENT_DEVICE_SELECTION_VALUE {
  ATHLETE = 0,
  ORGANIZATION = 1,
  OTHER = 2,
}
